import classNames from 'clsx';
import { ReactComponent as IconClose } from 'img/icons/remove.svg';
import React, { useEffect } from 'react';
import { ITopBannerProps } from 'reactApp/ui/TopBanner/TopBanner.types';

import styles from './TopBanner.css';

export const TopBanner: React.VFC<ITopBannerProps> = ({
    onClose,
    onClick,
    onShow,
    htmlContent,
    htmlMobileContent,
    height = 60,
    closeDarkTheme = false,
    isMobile = false,
}) => {
    const isMobileVer = htmlMobileContent && isMobile;

    const content = isMobileVer ? htmlMobileContent : htmlContent;

    useEffect(() => {
        if (content) {
            onShow();
        }
    }, []);

    if (!content) {
        return null;
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_mobile]: isMobileVer,
            })}
            style={{
                height: isMobileVer ? 130 : height,
            }}
        >
            <div className={styles.content} onClickCapture={onClick} dangerouslySetInnerHTML={{ __html: content }} />
            <div
                className={classNames(styles.close, {
                    [styles.close_dark]: closeDarkTheme,
                })}
                onClickCapture={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    onClose(event);
                }}
            >
                <IconClose width={22} height={22} />
            </div>
        </div>
    );
};
